import React, { useState } from 'react';
// import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux'
import { 
    TextField 
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { showAlertSnackbar } from '../../../reducers/uiSlice';
import UniDialog from "../../Common/UniDialog";
import { createSecondaryDelivery, getOrderInfo } from '../../../actions/editOrderActions';
import { operationLog } from '../../../actions/commonAction';
import { getUserPreference } from '../../../utilities/common';

// const useStyles = makeStyles((theme)=> ({
//       root: {
//         zIndex: theme.zIndex.modal - 1
//       },
// }))


// const DRIVER_MEMO_LENGTH = 120;
// const ORDER_MEMO_LENGTH = 120;
// const SHIPPING_FEE_MIN = 0;
// const SHIPPING_FEE_MAX = 99;

// const SHIPPING_FEE_PATTERN = "(?!^0\.0?0$)^[0-9][0-9]?(\.[0-9]{1,2})?$"
// const BUZZ_CODE_PATTERN = "^[A-Za-z0-9#*^%@!]{4,10}$";
// const DRIVER_MEMO_PATTERN = "^[A-Za-z0-9#*^%@!]{0,120}$";

// const DRIVER_MEMO_PATTERN_MSG = "length should be less than 120";
// const SHIPPINGFEE_PATTERN_MSG = "only number less than 100 is permited";
// const BUZZ_CODE_PATTERN_MSG = "length: 4- 10";

export default function SecondaryDelivery(props) {
    const { handleClose, orderInfo } = props;

    // const classes = useStyles();
    const {t} = useTranslation('editOrder');
    const dispatch = useDispatch();
    let userPref = getUserPreference();

    //used for secondary delivery
    const [scndryDlvryShippingFee,setScndryDlvryShippingFee] = useState(0);
    const [scndryDlvryUnitNo,setScndryDlvryUnitNo] = useState('');
    const [scndryDlvryBuzzCode,setScndryDlvryBuzzCode] = useState('');
    const [scndryDlvryDriverMemo,setScndryDlvryDriverMemo] = useState('');
    const [operationMemo, setOperationMemo] = useState('');
    const [loading, setLoading] = useState(false);

    let msg;

    function checkSubmitArgs() {
        let valid = true;

        if (!orderInfo.orders.order_sn) {
            valid = false;
            msg = "Order SN is required!";        
        } 

        if (!orderInfo.tracking.storage_info) {
            valid = false;
            msg = "Storage info is required!";        
        }

        if (isNaN(scndryDlvryShippingFee) || scndryDlvryShippingFee < 0 || scndryDlvryShippingFee >= 100) {
            valid = false;
            msg = "Invalid Shipping Fee! Must be a number between 0 and 99.";
        }

        if (scndryDlvryDriverMemo.length > 120) {
            valid = false;
            msg = "Order Memo too long! Max 120 characters."            
        }

        return valid;
    }

    /**
    * submit the secondary express request
    */
    async function handleSubmit() {
        if (checkSubmitArgs()) {
            setLoading(true);
            handleClose();
            try {
                let params = {};

                if (!orderInfo.orders.tno) {
                    params['trace_no'] = orderInfo.orders.tno;
                }
    
                params['order_sn'] = orderInfo.orders.order_sn;
                params['price'] = scndryDlvryShippingFee;
                params['apt_no'] = scndryDlvryUnitNo;
                params['buzz_code'] = scndryDlvryBuzzCode;
                params['postscript'] = scndryDlvryDriverMemo;
                params['storage_info'] = orderInfo.tracking.storage_info;
                params['version'] = 1;  //keep the older system call the API working which returns a different structure

                await dispatch(createSecondaryDelivery(params));
                await dispatch(operationLog(orderInfo.orders.order_id, userPref.username, 0, 1, 'CREATE_SECOND_DELIVERY', operationMemo));

                dispatch(showAlertSnackbar({title: 'success', 
                    message: "Created second delivery.",
                    type: 'success'
                }));

                dispatch(getOrderInfo(orderInfo.orders.order_id, 'order_id'))
            } catch (error) {
                dispatch(showAlertSnackbar({title: 'error', 
                    message: error.message,
                    type: 'error'
                }));
            } finally {
                setLoading(false);
                setOperationMemo('');
            }
        } else {
            dispatch(showAlertSnackbar({title: 'error', 
                message: msg,
                type: 'error'
            }));
        }
    }

    return (<>

        <UniDialog title={t('dialog_transfer_title')}
            open={true}
            fullWidth
            maxWidth='xs'
            onClose={handleClose}
            onFinish={handleSubmit}
            autoClose={false}
            buttonDisabled={loading}
        >
            <TextField label={t('shipping_fee')}
                variant='outlined'
                fullWidth
                autoFocus={true}
                type={'text'}
                value={scndryDlvryShippingFee === 0 ? '' : scndryDlvryShippingFee}
                onChange={ (e) => {setScndryDlvryShippingFee(e.target.value)} }
            />

            <TextField label={t('unit')} style={{marginTop: 10}}
                variant='outlined'
                fullWidth
                type={'text'}
                value={scndryDlvryUnitNo}
                onChange={ (e) => {setScndryDlvryUnitNo(e.target.value)} }
            />

            <TextField label={t('buzz_code')} style={{marginTop: 10}}
                variant='outlined'
                fullWidth
                type={'text'}
                value={scndryDlvryBuzzCode}
                onChange={ (e) => {setScndryDlvryBuzzCode(e.target.value)} }
            />
            
            <TextField label={t('order_memo')} style={{marginTop: 10}}
                variant='outlined'
                fullWidth
                type={'text'}
                value={scndryDlvryDriverMemo}
                onChange={ (e) => {setScndryDlvryDriverMemo(e.target.value)} }
            />

            <TextField 
                fullWidth
                multiline
                rows={2}
                variant="outlined"
                label={t('note')}
                InputLabelProps={{ shrink: true }}
                style={{marginTop: 20}}
                value={operationMemo}
                onChange={(e)=>{setOperationMemo(e.target.value)}}
            />
        </UniDialog>
    </>)

}
